import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/src/components/Docs/DocsLayout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Audience`}</h1>
    <p>{`Use attributes to target an specific audience.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`const userId = '676380e0-7793-44d6-9189-eb5868e17a86';
const experimentId = 'experiment-2';

tesfy.getVariationId(experimentId, userId, { countryCode: 've' }); // null
tesfy.getVariationId(experimentId, userId, { countryCode: 'us' }); // '0'
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      